module.exports = __webpack_public_path__ + "static/media/link-value.15d2fd38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link-value.svg
// module id = 2452
// module chunks = 0